<template>
    <div class="globales-section">
        <div class="globales-content">
            <h2 class="globales-title fuente-posm">
                Facturas Globales Automatizadas
            </h2>
            <p class="globales-text fuente-nova">
                La factura global ya no es solo declarar cuánto vendiste. Ahora el SAT exige el detalle de cada ticket que compone tu venta al público en general. Hacerlo manual con decenas o cientos de ventas diarias es prácticamente imposible.
                <br><br>
                Nosotros lo resolvemos: nuestro sistema genera tus facturas globales con el desglose completo de cada ticket, automáticamente.
            </p>
        </div>
        <div class="globales-image">
            <img :src="a62" alt="Facturas globales">
        </div>
    </div>
</template>

<script>
export default {
    name: 'FacturasGlobalesNew',
    data() {
        return {
            a62: require('@/assets/images/a62.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.globales-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.globales-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.globales-image img {
    width: 400px;
    height: auto;
}

.globales-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.globales-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.globales-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .globales-title {
        font-size: 60px;
    }

    .globales-text {
        font-size: 27px;
    }

    .globales-image img {
        width: 320px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .globales-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .globales-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .globales-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .globales-image img {
        width: 80%;
        max-width: 320px;
    }

    .globales-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .globales-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
